module.exports = __webpack_public_path__ + "img/panic.502f70d8.png";